import React from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

/**
 * `html` building block (VariableField registry, SCRUM-929) — a rich-text Quill (snow
 * theme) WYSIWYG whose stored value is the HTML string in settingVar.value.
 *
 * Mirrors the raw ReactQuill usage on the "Update page content" screen
 * (UpdatePageContent.jsx) and the Blog editors: same package (react-quill-new),
 * same snow theme + css, same "the first onChange arg is the HTML string"
 * contract. Sanitisation is a render-boundary concern (devlink/BottomText.js
 * sanitises before injection); authoring stores the raw Quill HTML, like every
 * other Quill surface in the app.
 *
 * Plain block (no `ownsChrome`): the dispatcher renders the variable-name label
 * row, like StringField / ContentStringField. Reads settingVar.value as a
 * string (default ""), reports edits via onChange(settingVar.variable, html).
 * Any host `options` / fieldProps are accepted and ignored.
 */
const asString = (v: unknown): string => (typeof v === "string" ? v : v == null ? "" : String(v));

export type RichTextFieldProps = {
  settingVar: { variable: string; value?: unknown };
  onChange: (name: string, value: string) => void;
};

export default function RichTextField({ settingVar, onChange }: RichTextFieldProps) {
  return (
    <ReactQuill
      id={settingVar.variable}
      theme="snow"
      value={asString(settingVar.value)}
      onChange={(html) => onChange(settingVar.variable, html)}
    />
  );
}
